import styled from 'styled-components/macro'

const FormItem = styled.div`
  margin-bottom: 30px;
  line-height: 1;
`
export default FormItem
